/** Copyright (c) 2018, MOBICOOP. All rights reserved. This project is dual
licensed under AGPL and proprietary licence. This program is free software: you
can redistribute it and/or modify it under the terms of the GNU Affero General
Public License as published by the Free Software Foundation, either version 3 of
the License, or (at your option) any later version. This program is distributed
in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the
implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details. You should have received a
copy of the GNU Affero General Public License along with this program. If not,
see gnu.org/licenses. Licence MOBICOOP described in the file LICENSE
**************************/

<template>
  <ion-page class="ion-page">
    <ion-header class="ion-no-border">
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button default-href="/hitchhiking/home"></ion-back-button>
        </ion-buttons>
        <h1 class="ion-text-center">Connexion</h1>
      </ion-toolbar>
    </ion-header>

    <ion-content color="primary" forceOverscroll="false">
      <div class="mc-white-container">
        <div class="text-center">
          <ion-spinner
            name="crescent"
            class="mc-st-loading-spinner"
          ></ion-spinner>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<style lang="scss"></style>

<script>
import { toast } from "../../Shared/Mixin/toast.mixin";
import { isPlatform } from "@ionic/core";
import { jwtDecode } from "jwt-decode";
import { PushNotifications } from "@capacitor/push-notifications";

export default {
  name: "eec-incentive",
  data() {
    return {
      loading: false,
      showMob: JSON.parse(process.env.VUE_APP_MOB),
      onlySSO: JSON.parse(process.env.VUE_APP_ONLY_SSO),
    };
  },
  mixins: [toast],
  props: [],
  mounted() {
    // Check if we are in a web browser on iOS (not in the native app)
    // In this case, we must NOT call the API because the redirection to custom scheme will happen
    // and the native app will then call the API with the SSO code
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isInNativeApp =
      window.Capacitor &&
      window.Capacitor.isNativePlatform &&
      window.Capacitor.isNativePlatform();

    if (isIOS && !isInNativeApp) {
      // Do nothing, the redirection to custom scheme will happen from App.vue
      // and the native app will call the API
      return;
    }

    if (this.$store.state.userStore.user) {
      this.mobConnect();
    } else {
      this.login();
    }
  },
  methods: {
    mobConnect() {
      const data = {
        userId: this.$store.state.userStore.user.id,
        body:
          this.$route.name == "eec-login"
            ? {
                ssoProvider: this.$route.query.state,
                ssoId: this.$route.query.code,
                baseSiteUri:
                  process.env.VUE_APP_DOMAIN.replace("m.", "") +
                  "/user/sso-mobile",
                redirectUri: "login",
                eec: 0,
              }
            : {
                ssoProvider: this.$route.query.state,
                ssoId: this.$route.query.code,
                baseSiteUri:
                  process.env.VUE_APP_DOMAIN.replace("m.", "") +
                  "/user/sso-mobile",
                eec: 1,
              },
      };
      this.$store
        .dispatch("patch_user", data)
        .then((res) => {
          this.presentToast("Connexion réussie", "success");
          if (this.$route.name == "eec-login") {
            this.getUser(res.id);
          } else {
            this.$router.replace({ path: "/hitchhiking/eec-incentive" });
          }
        })
        .catch((error) => {
          this.presentToast(this.getEECError(error), "danger");
        });
    },
    login() {
      let baseSiteUri =
        process.env.VUE_APP_DOMAIN.replace("m.", "") + "/user/sso-mobile";
      if (this.showMob) {
        baseSiteUri =
          process.env.VUE_APP_DOMAIN.replace("m.", "") + "/user/sso-mobile";
      }
      const data = {
        ssoProvider: this.$route.query.state,
        ssoId: this.$route.query.code,
        baseSiteUri: baseSiteUri,
        redirectUrl: this.onlySSO ? "login" : "",
      };

      this.$store
        .dispatch("loginSso", data)
        .then((res) => {
          this.getUser(jwtDecode(res.data.token).id);
        })
        .catch((error) => {
          this.presentToast(this.getEECError(error), "danger");
        });
    },
    getEECError(error) {
      switch (error.response.data["hydra:description"]) {
        case "eec_user_not_france_connected":
          return this.$t("Prime.errors.eec_user_not_france_connected");
        case "eec_user_sso_request_error":
          return this.$t("Prime.errors.eec_user_sso_request_error");
        case "eec_user_sso_account_incomplete":
          return this.$t("Prime.errors.eec_user_sso_account_incomplete");
        case "eec_user_sso_unknowned":
          return this.$t("Prime.errors.eec_user_sso_unknowned");
        case "eec_subscriptionType_unallowed":
          return this.$t("Prime.errors.eec_subscriptionType_unallowed");
        case "eec_subscriptionType_long_allready_subscribed":
          return this.$t(
            "Prime.errors.eec_subscriptionType_long_allready_subscribed"
          );
        case "eec_subscriptionType_short_allready_subscribed":
          return this.$t(
            "Prime.errors.eec_subscriptionType_short_allready_subscribed"
          );
        case "eec_subscription_long_unfinalized":
          return this.$t("Prime.errors.eec_subscription_long_unfinalized");
        case "eec_subscription_short_unfinalized":
          return this.$t("Prime.errors.eec_subscription_short_unfinalized");

        default:
          return this.$t("Commons.error");
      }
    },
    getUser(idUser) {
      const i18n = this.$i18n;
      // const t = $t("Login.logged");
      this.$store
        .dispatch("getUser", { idUser })
        .then((res) => {
          //  this.presentToast(t, 'success');
          this.presentToast("Vous êtes connecté", "success");
          this.email = "";
          this.password = "";

          const l = localStorage.getItem("language");
          i18n.locale = !!l ? l : "fr";

          this.$store.commit("user_request_success", res.data);

          if (!!this.$store.getters.redirectionUrl) {
            this.$router.replace({
              name: this.$store.getters.redirectionUrl.name,
              params: this.$store.getters.redirectionUrl.params,
            });
            this.$store.commit("redirectionUrl_reset");
          } else {
            let route = "/hitchhiking/home";
            this.$nextTick(() => {
              this.$router.push({ path: route });
            });
          }

          if (isPlatform(window.document.defaultView, "capacitor")) {
            PushNotifications.requestPermissions().then((result) => {
              if (result.granted) {
                // Register with Apple / Google to receive push via APNS/FCM
                PushNotifications.register();
              } else {
                // Show some error
              }
            });
          }
        })
        .catch((err) => {
          this.presentToast("Une erreur est survenue", "danger");
        });
    },
  },
};
</script>
